import Constants from '../../Constants';
import {
  drawMultiLineString,
  splitStringForMultiLine,
} from '../../drawingUtils';
import VirtualDomElement from '../VirtualDomElement';

export default class MultilineTextElement extends VirtualDomElement {
  constructor({
    text = '',
    fontSize = 10,
    x = 0,
    y = 0,
    maxCharacterWidth = 5,
    height = 20,
    color = '#000000',
    textAlign = 'center',
    ellipsis = true,
    maxLines = 2,
  }) {
    super();

    this.set('fontSize', fontSize);
    this.set('text', text);
    this.set('x', x);
    this.set('y', y);
    this.set('maxCharacterWidth', maxCharacterWidth); //vague approximation of text space (could optimize in the future)
    this.set('height', height);
    this.set('color', color);
    this.set('maxLines', maxLines);
    this.set('textAlign', textAlign);
    this.set('ellipsis', ellipsis);

    //calculate width and height by heuristic (otherwise would have to use measureText to compute exact width and height)
    const splitLinesForMultiString = splitStringForMultiLine(
      this.get('text'),
      this.get('maxCharacterWidth'),
      this.get('maxLines'),
      this.get('ellipsis'),
    );
    this.set(
      'width',
      Math.max(...splitLinesForMultiString.map(l => l.length)) *
        this.get('fontSize') *
        0.7,
    );
    const numberOfLines = Math.min(
      this.get('maxLines'),
      splitLinesForMultiString.length,
    );
    this.set('height', this.get('fontSize') * numberOfLines);
  }

  draw(ctx, transform) {
    const [xTitle, yTitle] = transform.apply([this.get('x'), this.get('y')]);
    const lineHeight = this.get('fontSize') * transform.k;

    ctx.font = `${this.get('fontSize') * transform.k}px ${Constants.general.fontFamily}`;
    ctx.fillStyle = '#474747';
    ctx.textAlign = this.get('textAlign');

    drawMultiLineString(
      ctx,
      this.get('text'),
      xTitle,
      yTitle,
      this.get('maxCharacterWidth'),
      lineHeight,
      this.get('maxLines'),
      this.get('ellipsis'),
    );
  }
}
